export default __webpack_public_path__ + "static/media/thumbnail.91391a19.png";